import { connect } from 'react-redux';
import { provideHooks } from 'redial';

import { fetchBasket, ensureBasketProducts } from 'apps/basket/actions/basket';
import { fetchDeliverySlot } from 'apps/deliverySlot/actions/deliverySlot';
import { fetchProperties } from 'apps/properties/actions/properties';
import { fetchExternalisedStrings } from 'apps/externalisedStrings/actions';
import { fetchFoodProfileStatus, initProductsSuitability } from 'apps/foodProfile/actions/foodProfile';
import { fetchFooterData } from 'apps/footer/actions/footer';
import { ensureMarketingCommunicationsConsents } from 'apps/settings/actions/preferences/marketingCommunications';
import { fetchTopNavigation } from 'apps/topNavigation/actions/topNavigation';
import { fetchUlpBannerData } from 'apps/ulp/actions/ulp';
import { calcIsVisible } from 'apps/appBanner/utils';
import { ensurePostcodeBanner } from '[theme-lib]/apps/header/actions/postcodeBanner';
import { fetchLogos } from 'apps/logosFromScribe/actions';

import RootView from '../components/RootView';
import { isCustomerAcquisition2018 } from 'features';

import { isDynamicYieldEnabled } from 'apps/dynamicYield';

export default provideHooks({
  server: ({ dispatch, location }) => Promise.all([
    dispatch(fetchTopNavigation()),
    new Promise((resolve, reject) => {
      dispatch(fetchBasket())
        .then(() => {
          dispatch(ensureBasketProducts()).then(resolve, reject);
        }, reject);
    }),
    dispatch(fetchDeliverySlot()),
    dispatch(fetchExternalisedStrings()),
    dispatch(fetchProperties()),
    dispatch(fetchFooterData()),
    dispatch(ensureMarketingCommunicationsConsents()),
    dispatch(fetchUlpBannerData(location.query.ULP_CAMPAIGN_ID)),
    dispatch(ensurePostcodeBanner()),
    dispatch(fetchLogos()),
  ]),
  defer: ({ dispatch }) => dispatch(fetchFoodProfileStatus()).then(
    () => dispatch(initProductsSuitability()),
    () => undefined // do nothing in case fetchFoodProfileStatus rejected
  ),
})(
  connect((state, ownProps) => ({
    deliverySlot: state.deliverySlot,
    footer: state.footer,
    isBookSlotPromptEnabled: isCustomerAcquisition2018(state),
    isDynamicYieldEnabled: isDynamicYieldEnabled(state.user.betaFeatures),
    isMobileAppBannerVisible: calcIsVisible(state.user.mobileAppBanner, ownProps.location),
    isUnsupportedBrowserAlertOpen: state.browserWarnings.isUnsupportedBrowserAlertOpen,
    isOfflineAlertOpen: state.browserWarnings.isOfflineAlertOpen,
    isOspHeader: state.user.betaFeatures.includes('ALTERNATIVE_HEADER_VER_O'),
    oneTrustDomainId: state.properties.oneTrustDomainId,
  }))(RootView)
);
